import React, { useEffect, useState } from 'react'
import './News.scss'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Header from '../components/Header'
import { getNews, getNewsDetail, getTagline, getVisionMission } from '../redux/actionCreator'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper'
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useTranslation } from 'react-i18next'
import { visionMision_lists } from '../redux/commonReducer'
import Footer from '../components/Footer'
import Head from '../constants/Head'
import { API_BASE_IMAGE_URL, API_BASE_URL } from '../constants/configuration'


function Home() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [newsCount, setNewsCount] = useState(0)

    const { t } = useTranslation();

    useEffect(() => {
        dispatch(getNews({}, (res) => {
            setData(res.home.slice(0, 3))
            setNewsCount(res.home.length)
            localStorage.setItem('newsCount', res?.home?.length > 0)
        }))
    }, [])

    return (
        <div id='News-Home'>
            {
                data?.length > 0 &&
                <>
                    <h2>{t('News')}</h2>
                    <div className='blocks'>
                        {
                            data.map((d, i) => {
                                return (
                                    <Block key={i} details={d} isHome />
                                )
                            })
                        }
                    </div>
                    <div className={'button _' + newsCount}>
                        <ViewMoreBtn onClick={() => navigate('news')} />
                    </div>
                </>
            }

        </div>
    )
}

function Listing() {

    const dispatch = useDispatch()
    const { t } = useTranslation();

    const [data, setData] = useState([])
    const [page, setPage] = useState(0)
    const [viewMore, setViewMore] = useState(true)

    useEffect(() => {
        dispatch(getNews({ page: 0, limit: 6 }, (res) => {
            setData(res.home)
            setViewMore(res.isViewMore)
        }))
    }, [])

    function viewMoreHandler() {
        dispatch(getNews({ page: page + 1, limit: 6 }, (res) => {
            setPage(s => s + 1)
            setData(s => [...s, ...res.home])
            setViewMore(res.isViewMore)
        }))
    }

    return (
        <div id='News-Listing'>
            <Head
                title={t("html_title.news")}
                metatitle={t("html_title.news")}
                metaDescription={t("html_title.news")}
            />
            <section className="banner">
                <div className='container sm-pad-0'>
                    <Header />
                    <Title />
                </div>
            </section>
            <section className='content container'>
                {
                    data.map((d, i) => {
                        return (
                            <Block key={i} details={d} />
                        )
                    })
                }
                {
                    Array((Math.ceil(data.length / 3) * 3) - data.length).fill().map((item, i) => {
                        return <div style={{ flex: '1 1 300px' }} key={i}></div>
                    })
                }
                {data.length === 0 && <div id="preloader">
                    <img src="./assets/img/loader.gif" alt="" />
                </div>}
            </section>
            {viewMore && <div className='button'>
                <ViewMoreBtn onClick={viewMoreHandler} isBlue />
            </div>}
            <Footer />
        </div>
    )
}

function Details() {

    const { id } = useParams()

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const { t } = useTranslation();

    const lang = location.pathname.includes('/ar/') ? 'ar' : 'en'

    const [data, setData] = useState([])

    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(getNewsDetail(id, (res) => {
            res.status
                ? setData(res.news)
                : navigate(`/${lang}/news`)
        }))
    }, [])

    return (
        <div id='News-Details'>
            {data.length === 0 && <div id="preloader">
                <img src="./assets/img/loader.gif" alt="" />
            </div>}
            <Head
                title={t("html_title.news")}
                metatitle={t("html_title.news")}
                metaDescription={t("html_title.news")}
            />
            <section className="banner">
                <div className='container sm-pad-0'>
                    {/* <img src="./assets/img/incident.jpg" className="banner__background w-100" /> */}
                    <Header />
                    <Title onTitleClick={() => navigate(`/${lang}/news`)} />
                </div>
            </section>
            <section className='content container'>
                <Block isDetail details={data} />
            </section>
            <Footer />
        </div>
    )
}

export default {
    Home,
    Listing,
    Details
}

const Block = ({ isHome, isDetail, details }) => {
    const navigate = useNavigate()
    return (
        <div id='News-Block' className={isDetail ? 'detail' : 'block'} onClick={() => !isDetail && navigate(isHome ? 'news/' + details?._id : details?._id)}>
            <div className='image'>
                {
                    isDetail
                        ? <Swiper pagination={{ clickable: true }} navigation={true} modules={[Pagination, Navigation]} className="mySwiper">
                            {[{ gallery_item: details?.thumbnail, gallery_type: 'image' }, ...(details?.gallery || [])].map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        {item?.gallery_type === "video"
                                            ? <iframe
                                                src={item?.gallery_item}
                                                title="YouTube video player"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                            : <img
                                                src={`${API_BASE_IMAGE_URL}news/${item?.gallery_item}`}
                                                style={{ marginBottom: 35 }}
                                                alt=""
                                            />
                                        }
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                        : <img
                            src={details?.thumbnail
                                ? `${API_BASE_IMAGE_URL}news/${details?.thumbnail}`
                                : ''
                            }
                            alt=''
                        />
                }

            </div>
            <p className='date'>{moment(details?.news_date).format('DD MMM YYYY')}</p>
            <p className='title'>{details?.['title_' + localStorage.getItem('lang')]}</p>
            {/* <p className='description'>{details?.detail_en}</p> */}
            <div className='description' dangerouslySetInnerHTML={{ __html: details?.['detail_' + localStorage.getItem('lang')] }}></div>
        </div>
    )
}

const ViewMoreBtn = ({ isBlue, onClick }) => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    return <span id='ViewMoreBtn' onClick={() => onClick && onClick()}>
        <button>{t('View More')}</button>
        {
            isBlue
                ? <img src='/assets/img/icons/view_more.svg' alt='' />
                : <img src='/assets/img/icons/view_more_white.svg' alt='' />
        }
    </span>
}

const Title = ({ isHome, onTitleClick }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch()
    const language = localStorage.getItem("lang")
    const [tagline, setTagLine] = useState({})

    const visionMisionLists = useSelector(visionMision_lists);
    useEffect(() => {
        dispatch(getVisionMission());
        dispatch(getTagline((res) => {
            setTagLine(res)
        }))
    }, []);



    return <div id='News-Title' className='news__details'>
        <img src="./assets/img/incident.jpg" className="banner__background w-100" />
        <div className="contents">
            <div className="row d-flex align-items-center justify-content-between ">
                <div className="col-md-4">
                    <div className="header__title">
                        <h2 onClick={onTitleClick} style={{ cursor: onTitleClick ? 'pointer' : 'auto' }}>{t('News')}</h2>
                    </div>
                </div>


                <div className="col-md-6">
                    <div className="tagline">
                        <p dangerouslySetInnerHTML={{ __html: language == 'en' ? tagline?.tagline_en : tagline?.tagline_ar }}></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
}